import React from 'react';
import { useSelector } from 'react-redux';
import Dialog from 'components/Ui/Dialog';
import { ProcessingBlock } from 'components/Ui';
import {
  selectIsDeliveryUpdating,
  selectServiceLocationIsRecurringOrderUpdating,
} from 'containers/PrimoAccount/selectors';

const ProcessingModal = () => {
  const isUpdating = useSelector(selectIsDeliveryUpdating());
  const isRecurringOrderUpdating = useSelector(
    selectServiceLocationIsRecurringOrderUpdating(),
  );

  return (
    <Dialog
      size="small"
      open={isUpdating || isRecurringOrderUpdating}
      isCloseIcon={false}
    >
      <ProcessingBlock />
    </Dialog>
  );
};

export default ProcessingModal;
